import { FC, useMemo } from "react";

import { cn } from "./utils";

export interface UserAvatarProps {
  email: string;
  name?: string;
  className?: string;
}

export const UserAvatar: FC<UserAvatarProps> = ({ email, name, className }) => {
  const initial = (name?.[0] ?? email?.[0])?.toUpperCase() ?? "-";

  const backgroundColor = useMemo(() => {
    if (!email) {
      return "bg-gray-300";
    }
    const colors = [
      "bg-blue-300",
      "bg-blue-400",
      "bg-blue-500",
      "bg-blue-600",
      "bg-blue-700",
      "bg-sky-400",
      "bg-sky-500",
      "bg-sky-600",
      "bg-indigo-500",
      "bg-cyan-500",
    ];
    let hash = 0;
    for (let i = 0; i < email.length; i++) {
      // eslint-disable-next-line no-bitwise
      hash = email.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
  }, [email]);

  return (
    <div
      className={cn(
        "flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-semibold text-white",
        backgroundColor,
        className,
      )}
    >
      {initial}
    </div>
  );
};
